import { RoleResource, roleResource } from '@witkac/kartamiejska-resources';
import { RoleObjectType } from '@witkac/kartamiejska-shared';

import store from '@/store/store';

import { EntityModule } from '../entity.module';

/**
 * Moduł ról przypisanych do użytkownika
 *
 * @export
 * @class UserRoleModule
 * @extends {EntityModule<RoleObjectType, RoleResource>}
 */
export class UserRoleModule extends EntityModule<RoleObjectType, RoleResource> {
  constructor() {
    super(roleResource);
    this.actions = {
      ...this.actions,
      /**
       * Dodaje rolę do użytkownika
       *
       * @param context context
       * @param userId id użytkownika
       */
      list: async (context: any, userId: string): Promise<void> => {
        const list = await this.resource.userRoles(userId);
        context.commit('saveList', list);
      },
      /**
       * Usuwa rolę użytkownikowi
       *
       * @param context context
       * @param data dane do wysłania do API
       */
      remove: async (context: any, data: any): Promise<void> => {
        await this.resource.userRoleDelete(data.roleId, data.userId, data.entityType, data.entityId);
        store.dispatch('profiles/userRole/list', data.userId);
      },
      /**
       * Dodaje rolę do użytkownika
       *
       * @param context context
       * @param data dane do wysłania do API
       */
      add: async (context: any, data: any): Promise<void> => {
        await this.resource.userRoleAdd(data.roleId, data.userId, data.entityType, data.entityId);
        store.dispatch('profiles/userRole/list', data.userId);
      }
    };
  }
}

export default new UserRoleModule();
